import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/PersonaNavbar';
import Footer from '../../components/PersonaFooter';
import FilteredTable from '../../components/PersonaTable';

const filterOptions = [
  {
    label: "Industry",
    property: "industry",
    values: [
      "Finance & FinTech",
      "Healthcare & Life Sciences",
      "Security & Compliance",
      "IT & Cloud Infrastructure",
      "E-commerce & Retail",
      "Marketing & AdTech",
      "HRTech & Workforce",
      "Productivity & Collaboration",
      "Customer Support & Experience",
      "Manufacturing & Industrial",
      "Education & EdTech",
      "LegalTech & Contract",
      "Logistics & Supply Chain",
      "Real Estate & PropTech",
      "Energy & Sustainability",
      "AI & MLOps"
  ]
  },
  {
    label: "Company Size",
    property: "employee_range",
    values: ["10-100", "100-1000", "1000+"]
  },
  {
    label: "Department",
    property: "role_set_name",
    values: [
      "Engineering",
      "Finance",
      "Entrepreneurship",
      "Legal",
      "Operations",
      "Product Management",
      "Quality Assurance",
      "Arts and Design",
      "Human Resources",
      "Information Technology",
      "Marketing",
      "Consulting",
      "Business Development",
      "Customer Success",
      "Sales",
      "Community and Social Services",
      "Administrative",
      "Executive Leadership",
      "Accounting",
      "Customer Success and Support",
      "Program and Project Management",
      "Media and Communication",
      "Research",
      "Healthcare Services",
      "Education",
      "Data & Analytics",
      "Talent Development",
      "Compliance",
      "Risk Management",
      "Supply Chain",
      "Procurement",
      "Corporate Strategy",
      "Learning and Development",
      "Enterprise Architecture",
      "Security & Compliance",
      "Purchasing",
      "Enterprise Resource Planning (ERP)",
      "Research & Development (R&D)"
  ]
  },
];

const Persona: React.FC = () => {
  const location = useLocation();
  const [initialFilters, setInitialFilters] = useState<{ property: string; values: string[]; }[]>([]);
  
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const newFilters: { property: string; values: string[]; }[] = [];
    
    // Parse query parameters and create filter objects
    queryParams.forEach((value, property) => {
      if (value) {
        newFilters.push({
          property,
          values: [value]
        });
      }
    });
    
    setInitialFilters(newFilters);
  }, [location.search]);

  const handleFiltersChange = (filters: { property: string; values: string[]; }[]) => {
    // Here you would typically:
    // 1. Update your application state with the new filters
    // 2. Make an API call with the new filters
    console.log('Filters changed:', filters);
    
    // Example of how you might make an API call:
    // fetchData(filters);
  };

  return (
    <div className='flex flex-col min-h-screen bg-white'>
      <Navbar />
      <main className='flex-grow'>
        <FilteredTable 
          filterOptions={filterOptions} 
          onFiltersChange={handleFiltersChange}
          initialFilters={initialFilters}
        />
      </main>
      <Footer />
    </div>
  );
};

export default Persona;
